// initialize as default
var serverAddr = "https://initialview.com";
var staticAddr = "https://initialview.com";
var wsServerAddr = "wss://initialview.com";

if (["test.initialview.com", "lab-nk.initialview.com", "lab-nb.initialview.com", "lab-nsk.initialview.com", "lab-sc.initialview.com", "lab-d1.initialview.com", "lab-d2.initialview.com", "lab-d5.initialview.com", "lab-wq.initialview.com", "lab-d3.initialview.com", "lab-d4.initialview.com", "lab-d6.initialview.com", "lab-d7.initialview.com", "lab-d8.initialview.com"].includes(window.location.hostname)) {
  serverAddr = "https://" + window.location.hostname;
  staticAddr = "https://" + window.location.hostname;
  wsServerAddr = "wss://" + window.location.hostname;
}
// Local docker-compose-local.yaml stack; static content comes from test
else if (window.location.hostname == "local.initialview.com") {
  serverAddr = "https://local.initialview.com";
  staticAddr = "https://test.initialview.com";
  wsServerAddr = "wss://local.initialview.com";
}
else if ("initialview.cn" == window.location.hostname) {
  serverAddr = "https://initialview.cn";
  staticAddr = "https://prod-cdn-ali.initialview.cn";
  wsServerAddr = "wss://initialview.com";
}
else if ("test.initialview.cn" == window.location.hostname) {
  serverAddr = "https://test.initialview.cn";
  staticAddr = "https://test-cdn-ali.initialview.cn";
  wsServerAddr = "wss://test.initialview.com";
}
else if ("localhost" == window.location.hostname) {
  serverAddr = "https://localhost";
  staticAddr = "https://localhost";
  wsServerAddr = "wss://localhost";
}

export default {
   serverAddr: serverAddr,
   staticAddr: staticAddr,
   wsServerAddr: wsServerAddr,
}

